import React from "react";
import { ExternalLink, Clock } from "lucide-react";
import { Button } from "@/components/ui/button";
import Logo from "@/components/Logo";

interface InstagramCTAProps {
  title: string;
  description: string;
  buttonText: string;
  logoImage?: string;
  variant?: "default" | "countdown";
  onAction?: () => void;
}

const InstagramCTA: React.FC<InstagramCTAProps> = ({
  title,
  description,
  buttonText,
  logoImage,
  variant = "default",
  onAction,
}) => {
  return (
    <div className={`w-full rounded-lg p-6 border ${
      variant === "countdown" 
        ? "bg-gradient-to-r from-sauna-blue/10 to-sauna-orange/10 border-sauna-blue/20" 
        : "bg-gradient-to-r from-sauna-orange/10 to-sauna-blue/10 border-sauna-orange/20"
    }`}>
      <div className="flex flex-col md:flex-row items-center gap-6">
        {logoImage && (
          <div className="shrink-0">
            <Logo className="h-24 w-auto" />
          </div>
        )}
        
        {variant === "countdown" && !logoImage && (
          <div className="shrink-0 bg-sauna-blue/20 h-24 w-24 rounded-full flex items-center justify-center">
            <Clock size={40} className="text-sauna-blue" />
          </div>
        )}
        
        <div className="flex-1 space-y-3">
          <h3 className="text-xl font-semibold text-sauna-navy">{title}</h3>
          <p className="text-sauna-navy/80">{description}</p>
          
          <Button 
            onClick={onAction}
            className={`${
              variant === "countdown"
                ? "bg-gradient-to-r from-sauna-blue to-sauna-orange hover:opacity-90"
                : "bg-gradient-to-r from-sauna-orange to-sauna-blue hover:opacity-90"
            } text-white font-semibold mt-2`}
          >
            <ExternalLink size={18} className="mr-2" />
            {buttonText}
          </Button>
        </div>
      </div>
    </div>
  );
};

export default InstagramCTA;
